import React from "react";
import RoutesWrapper from "./Routes";
import "./styles/main.scss";
import { Helmet } from "react-helmet-async";
import { useSelector } from "react-redux";
import { DEFAULT_CONTENT } from "./constants/defaultContent";

function App() {
  const { contentData } = useSelector((state) => state.content);

  return (
    <div className="">
      <Helmet>
        <meta
          name="description"
          content={contentData.descriptionSEO || DEFAULT_CONTENT.descriptionSEO}
        />
        <meta
          name="keywords"
          content={contentData.keywordSEO || DEFAULT_CONTENT.keywordSEO}
        />
      </Helmet>
      <RoutesWrapper />
    </div>
  );
}

export default App;
